/**
 * @Author: wangtieshou
 * @Date:   2017/1/29
 */

class Modal {
    constructor(config) {

        this.config = {
            title:'',
            subtitle:'',
            footerClass: '',
            content:'',
            shown:function () {

            }
        }


        if (config) {
            for (let k in config) {
                this.config[k] = config[k]
            }
        }

        this.config.tpl = this.renderTpl();


        this.event()

    }

    renderTpl() {
        return `
<div class="modal">
    <div class="modal__mask">
        <div class="modal__box">
            <div class="modal__heading">
                <span class="modal__btn-close">✕</span>
                <h3>${this.config.title}</h3>
                <p>${this.config.subtitle}</p>
            </div>
            <div class="modal__body">
            ${this.config.$content}
            ${this.config.content}
            </div>
            <div class="modal__action text-right ${this.config.footerClass}">
                <button type="button" class="btn btn--primary modal__action-ok">提交</button>
            </div>
        </div>
    </div>
</div>
`;


    }

    event() {
        document.body.addEventListener('click', (e) => {
            if (e.target.className === 'modal__mask' || e.target.className === 'modal__btn-close') {
                this.$div?this.$div.remove():''
            }
        })

        document.body.addEventListener('click', (e) => {
            if (e.target.classList.contains(this.config.ele)) {
                this.show()
            }
        })

        // document.body.addEventListener('click', (e) => {
        //     if (e.target.classList.contains('modal__action-ok')) {
        //         document.querySelector('.form--contact').submit()
        //     }
        // })

    }

    show() {
        this.$div = document.createElement('div');
        this.$div.innerHTML = this.config.tpl;
        document.body.append(this.$div)

        if(this.config.shown){
            this.config.shown()
        }
    }

}
;

let modal = function (cf) {
    return new Modal(cf)
};

export default modal;


// WEBPACK FOOTER //
// ./modal.js